import React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import SC from "./style";

function TableList({ items, popupState, sx }) {
  return (
    <>
      {SC.Globalstyles}
      <List>
        {items.map((item) => (
          <ListItem
            button
            key={item.id}
            onClick={(e) => {
              item.onClick(e);
              popupState?.close && popupState.close(); // Add null check
            }}
            sx={sx}
          >
            {item.icon && <span>{item.icon}</span>}
            <span
              style={{ fontWeight: "bold", fontSize: "11px", opacity: "0.8" }}
            >
              {item.text}
            </span>
          </ListItem>
        ))}
      </List>
    </>
  );
}

export default TableList;
